<div class="modal-loading-background-comp"></div>
<div class="loader-comp">Loading...</div>